// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".eFpal{cursor:zoom-in;transition:z-index .2s}._0Pq-U,.eFpal{position:relative;z-index:1}._0Pq-U{transform-origin:top left;transition:transform .3s}.I98DH{position:fixed;top:0;left:0;width:100vw;height:100vh;background-color:rgba(0,0,0,.8)}.eFpal.x-uvN{z-index:999999999;cursor:zoom-out}.eFpal.x-uvN ._0Pq-U>*,.eFpal.x-uvN ._0Pq-U>*>*,.eFpal.x-uvN ._0Pq-U>*>:after,.eFpal.x-uvN ._0Pq-U>*>:before,.eFpal.x-uvN ._0Pq-U>:after,.eFpal.x-uvN ._0Pq-U>:before{border:0!important;border-radius:0!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"zoomable": "eFpal",
	"content": "_0Pq-U",
	"blackout": "I98DH",
	"isFloating": "x-uvN"
};
module.exports = ___CSS_LOADER_EXPORT___;
